import React, {Component} from 'react';
import {Collapse, DropdownItem, DropdownMenu} from 'reactstrap';
import {FontAwesomeIcon} from '../../../components/ui/FontAwesomeIcon';
import {IHierarchyOption} from './interfaces';

interface IWithinSelectorProps {
  updateWithin: (avidID: string) => void;

  isOpen: boolean
  rankAvids: IHierarchyOption[]
  withinOptions: string[]
}

interface IWithinSelectorState {
  expandedAvids: string[]
}

export class WithinSelector extends Component<IWithinSelectorProps, IWithinSelectorState> {
  state: IWithinSelectorState = {
    expandedAvids: []
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen)
      this.setState({expandedAvids: []})
  }

  renderWithinOption(avid: string, indent: number) {
    const {updateWithin, rankAvids} = this.props;
    let { expandedAvids } = this.state
    let withinChildrenOptions = [];

    const withinAvid = rankAvids.find((avidInstance) => avidInstance.hierarchy == avid);
    if (withinAvid && withinAvid.children && withinAvid.children.length > 0) {
      withinChildrenOptions = withinAvid.children.reduce((acc, curr) => {
        if (curr.avid) return acc.concat(curr.avid.label)
      }, []);
    } else withinChildrenOptions = [];

    const padding = 1.5 + indent;
    const paddingSet = `${padding}em`;

    return (
      <Collapse isOpen key={'avid-item' + avid}>
        <DropdownItem style={{paddingLeft: paddingSet}}>
          <div>
            <span onClick={() => {
              this.setState({expandedAvids: []})
              updateWithin(avid)
            }}>{avid}</span>
          </div>

        </DropdownItem>
        {
          withinChildrenOptions.map((childAvid) => {
            if (expandedAvids.includes(withinAvid.hierarchy)) {
              return this.renderWithinOption(childAvid, indent + 1);
            }
          })
        }
      </Collapse>
    )
  }

  handleClick(e, withinAvid) {
    let { expandedAvids } = this.state
      // e.stopPropagation()
      //
      if (!expandedAvids.includes(withinAvid.hierarchy)) {
        expandedAvids = expandedAvids.concat(withinAvid.hierarchy)
      } else expandedAvids = expandedAvids.filter(i => i !== withinAvid.hierarchy)
      this.setState({expandedAvids: expandedAvids})
  }

  render() {
    const {rankAvids, withinOptions} = this.props
    return (
      <DropdownMenu className='user-select-dropdown-menu'>
        <DropdownItem disabled>Select One</DropdownItem>
        {rankAvids &&
        withinOptions.map((avid, index) => {
          return (
            this.renderWithinOption(avid, 0)
          );
        })
        }
      </DropdownMenu>
    );
  }
}
